/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';

import {
  closeMobileMenu,
  setShowUsage,
  toggleMobileMenu,
  toggleShowUsage,
  toggleSidebar,
} from './actions';
import { LS_SIDEBAR_COLLAPSED, LS_SIDEBAR_SHOW_USAGE } from './constants';

export interface DashboardContainerNewState {
  isCollapsed: boolean;
  isMobileCollapsed: boolean;
  showUsage: boolean;
}

const getLSBoolean = (key: string) => Boolean(
  JSON.parse(window.localStorage.getItem(key) ?? 'false'),
);

const createInitialState: () => DashboardContainerNewState = () => ({
  isCollapsed: getLSBoolean(LS_SIDEBAR_COLLAPSED),
  isMobileCollapsed: true,
  showUsage: getLSBoolean(LS_SIDEBAR_SHOW_USAGE),
});

export const containerReducer = createReducer(createInitialState(), (builder) => {
  builder.addCase(toggleSidebar, (state) => {
    const newCollapsedState = !state.isCollapsed;
    window.localStorage.setItem(LS_SIDEBAR_COLLAPSED, JSON.stringify(newCollapsedState));
    state.isCollapsed = newCollapsedState;
  });
  builder.addCase(closeMobileMenu, (state) => {
    state.isMobileCollapsed = true;
  });
  builder.addCase(toggleMobileMenu, (state) => {
    state.isMobileCollapsed = !state.isMobileCollapsed;
  });
  builder.addCase(toggleShowUsage, (state) => {
    const newShowUsageState = !state.showUsage;
    window.localStorage.setItem(LS_SIDEBAR_SHOW_USAGE, JSON.stringify(newShowUsageState));
    state.showUsage = newShowUsageState;
  });
  builder.addCase(setShowUsage, (state, { payload }) => {
    const newShowUsageState = typeof payload === 'boolean' ? payload : payload(state.showUsage);
    window.localStorage.setItem(LS_SIDEBAR_SHOW_USAGE, JSON.stringify(newShowUsageState));
    state.showUsage = newShowUsageState;
  });
});

export default containerReducer;
